import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useConferenceCreate } from '@/module/Conference/model/ConferenceQuery';
import {
  ConferenceSchema,
  conferenceSchema,
  defaultConferenceValues,
} from '@/module/Conference/model/ConferenceSchema';

import { useAppNotification } from '@feature/utils';

import { ConferenceForm } from './ConferenceForm';

export function ConferenceCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useConferenceCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: ConferenceSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newConference => {
        notification.success();
        navigate({ to: '/conference/$conferenceId', params: { conferenceId: String(newConference.id) } });
      },
    });
  };

  return (
    <ConferenceForm
      title={t('conferences.form.title.create')}
      schema={conferenceSchema}
      defaultValues={defaultConferenceValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
